<template>
  <div class="especificas-root">
    <div class="filters-row columns is-multiline">
      <div class="column is-6">
        <search-bar
          :onSearch="debouncedOnSearch"
          tooltipLabel="informacao-campo-busca-parametrizacao-especificas-por-usuario"
        />
      </div>

      <div class="column is-3">
        <vss-select
          class="selecione-categoria"
          title="selecione-categoria"
          :options="categorias"
          v-model="categoria"
          @onBlurFunction="onCategoriaChanged"
          tooltipLabel="informacao-campo-categoria-parametrizacao"
          :height="40"
        />
      </div>

      <div class="column is-3">
        <vss-select
          class="selecione-categoria"
          title="situacao"
          ref="situacaoInput"
          :options="situacoes"
          @input="filterSituacao"
          v-model="situacao"
          :height="40"
        />
      </div>
    </div>

    <div class="registry-wrapper">
      <div class="table-scroll-area">
        <loading :isLoading="isLoading" />
        <div v-if="isEmpty" class="empty-wrapper">
          <empty-table-message />
        </div>
        <b-table
          v-else
          responsive
          :data="usrsConfigs"
          class="data-table data-table-label-word-wrap remove-padding"
          @sort="sortTable"
          backend-sorting
        >
          <b-table-column
            v-for="(f, i) in fields"
            :key="i"
            :field="f.key"
            :label="f.label"
            :width="f.width"
            :class="f.key === 'excluir' ? 'excluir-field' : ''"
            :sortable="f.sortable"
            :custom-sort="f.sortFn"
            v-slot="props"
          >
            <div v-if="f.key === 'usuario'">
              <router-link
                :to="{
                  name: 'config-parametrizacoes-edit',
                  params: {
                    id: props.row.id,
                    idusuario: props.row.user.idusuario,
                    config: props.row.nome,
                  },
                  query: {
                    abaSelecionada: $route.query.abaSelecionada,
                  },
                }"
              >
                <pre>{{ props.row.usuario }}</pre>
              </router-link>
            </div>

            <div v-else-if="f.key === 'nome'">
              {{ props.row.nome }}
            </div>

            <div v-else-if="f.key === 'valor'">
              {{ props.row.valor }}
            </div>

            <div v-else-if="f.key === 'descricao'">
              {{ cutString(props.row.descricao, 100) }}
            </div>

            <div v-else-if="f.key === 'situacao'">
              <b-tag
                :type="props.row.situacao == 1 ? 'is-success' : 'is-danger'"
                size="is-medium"
                class="table-tag table-tag-full-width mr-1 mb-1"
              >
                {{ props.row.situacao == 1 ? $t("ativo") : $t("inativo") }}
              </b-tag>
            </div>

            <div v-else-if="f.key === 'excluir'">
              <b-button
                class="align-center-btn"
                v-if="permissao.delete"
                :type="props.row.situacao == 1 ? 'is-danger' : 'is-success'"
                @click="promprConfirm({ ...props.row })"
                :icon-right="props.row.situacao == 1 ? 'delete' : 'check'"
                position="is-left"
                v-tippy
                :title="$t(props.row.situacao == 1 ? 'desativar' : 'reativar')"
              />
            </div>
          </b-table-column>
        </b-table>
      </div>

      <PaginationViewer
        class="pagination-footer"
        :resetPagination="pagination.resetPagination"
        :totalItems="pagination.totalRows"
        :perPageOptions="pagination.perPageOptions"
        :optionStarted="pagination.optionStarted"
        @change="updatePagination"
      />
    </div>
  </div>
</template>

<script>
import UserParametrizacaoManage from "@/components/conta/parametrizacoes/pages/UserParametrizacaoManage.vue";

export default {
  components: {
    UserParametrizacaoManage,
  },
  props: {
    permissao: {
      type: Object,
      default: {},
    },
    rotaAninhada: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedRow: null,
      fields: [
        {
          key: "usuario",
          label: "Nome do Usuário",
          width: 100,
          sortable: true,
        },
        {
          key: "nome",
          label: "Parametrizações",
          width: 150,
          sortable: true,
        },
        {
          key: "valor",
          label: "Valores",
          width: 50,
          sortable: false,
        },
        {
          key: "descricao",
          label: "Descrição",
          width: 250,
          sortable: false,
        },
        {
          key: "situacao",
          label: "Situação",
          width: 80,
          sortable: false,
        },
        { key: "excluir", width: 20, sortable: false, sortFn: null },
      ],
      pagination: {
        resetPagination: false,
        perPageOptions: [10, 25, 50, 100],
        optionStarted: 0,
        perPage: null,
        totalRows: 0,
        currentPage: 1,
      },
      sort: "usuario",
      order: "asc",
      isLoading: false,
      isEmpty: false,
      categorias: [{ id: 0, label: this.$t("todos") }],
      categoria: { id: 0, label: this.$t("todos") },
      debouncedOnSearch: null,
      queryFilter: "",
      situacoes: [
        { id: 2, label: "Todos" },
        { id: 1, label: "Ativos" },
        { id: 0, label: "Inativos" },
      ],
      situacao: { id: 2, label: "Todos" },
      usrsConfigs: [],
    };
  },
  watch: {
    rotaAninhada(val) {
      if (!val) this.carregarDados(this.pagination.currentPage);
    },
  },
  created() {
    this.pagination.perPage =
      this.pagination.perPageOptions[this.pagination.optionStarted];

    this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    this.carregarDados();
    this.carregarCategorias();
  },
  methods: {
    onSearch(value) {
      this.queryFilter = value;
      this.pagination.currentPage = 1;
      this.carregarDados(this.pagination.currentPage);
    },
    sortTable(field, order) {
      this.sort = field;
      this.order = order;
      this.carregarDados();
    },
    updatePagination(value) {
      this.pagination.resetPagination = false;
      this.pagination.perPage = value.perPage;
      this.pagination.currentPage = value.currentPage;
      this.carregarDados(value.currentPage);
    },
    carregarDados(currentPage = 1) {
      if (currentPage == 1 && this.pagination.currentPage != 1)
        this.pagination.resetPagination = true;

      this.isLoading = true;

      const params = new URLSearchParams();

      params.append("page", currentPage - 1);
      params.append("limit", this.pagination.perPage);
      params.append("situacao", this.situacao.id);
      params.append("order", this.order);
      params.append("sort", this.sort);
      params.append(
        "param",
        this.categoria && this.categoria.id ? this.categoria.id : 0
      );
      params.append(
        "param",
        this.queryFilter && this.queryFilter.length > 0
          ? this.queryFilter
          : ".*"
      );
      this.$axios
        .get(`/config/usuario/parametrizacoes.json`, {
          params: params,
        })
        .then(this.mapItems)
        .then((value) => {
          this.usrsConfigs = value;
          this.isEmpty = this.usrsConfigs.length <= 0;
        })
        .catch((_) => {
          this.isEmpty = true;
          this.$root.showMessage("error", "msg-erro-load");
        })
        .finally((_) => {
          this.isLoading = false;
          this.pagination.resetPagination = false;
        });
    },
    mapItems(body) {
      this.pagination.totalRows = body.data.totalElements;
      return body.data.content.map((m) => {
        return {
          ...m,
          usuario: m.user.nome,
        };
      });
    },
    carregarCategorias() {
      this.$axios
        .get("/config/getcombo/categoriaconfig.json")
        .then((value) => {
          if (value.data.status === 200) {
            if (value.data.content) {
              value.data.content.map((e) => {
                this.categorias.push({
                  id: e.idcategoriaconfig,
                  label: e.nome,
                });
              });
            }
          } else {
            this.categorias = [];
            this.categoria = null;
            this.$root.showMessage("error", "msg-erro-load", true);
          }
        })
        .catch((e) => {
          this.categorias = [];
          this.categoria = null;
          console.error(e);
        });
    },
    onCategoriaChanged() {
      this.carregarDados(this.pagination.currentPage);
    },
    filterSituacao(value) {
      if (value) {
        this.situacao = value;
      } else {
        this.situacao = this.situacoes[0];
      }
      this.carregarDados(this.pagination.currentPage);
    },
    promprConfirm(item) {
      this.$root.confirm({
        message:
          item.situacao == 1
            ? this.$t("msg-confirmacao-desativacao-n", {
                n: item.nome,
              })
            : this.$t("msg-confirmacao-reativacao-n", {
                n: item.nome,
              }),
        onConfirm: () => this.updateSituacao(item),
      });
    },
    updateSituacao(item) {
      this.isLoading = true;
      let parametrizacao = {
        id: item.id,
        idconfigusuario: item.idconfigusuario,
        situacao: item.situacao == 1 ? 0 : 1,
      };
      this.$axios
        .post(`/config/usuario/parametrizacao/update`, parametrizacao)
        .then((response) => {
          if (response.status === 200) {
            this.carregarDados(this.pagination.currentPage);

            let msgSuccess = this.$t(
              parametrizacao.situacao == 1
                ? "msg-sucesso-ao-reativar-n"
                : "msg-sucesso-ao-desativar-n",
              { n: item.nome.toLocaleUpperCase() }
            );

            this.$root.showMessage("success", msgSuccess);
          } else {
            let msgError = this.$t(
              parametrizacao.situacao == 1
                ? "msg-erro-ao-reativar-n"
                : "msg-erro-ao-desativar-n",
              { n: item.nome.toLocaleUpperCase() }
            );

            this.$root.showMessage("error", msgError);
          }
        })
        .catch((e) => {
          this.$root.showMessage("error", "msg-erro-load");
        })
        .finally((_) => {
          this.isLoading = false;
        });
    },

    cutString(str, max) {
      if (!str) return "";
      if (str.length <= max) return str;
      return str.substring(0, max).trim() + "...";
    },
  },
};
</script>

<style lang="scss" scoped>
.especificas-root {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.filters-row {
  flex-shrink: 0;
  margin-bottom: 0.5rem;
}

.registry-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.table-scroll-area {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.empty-wrapper {
  flex: 1;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-footer {
  flex-shrink: 0;
  margin-top: 8px;
}

.align-center-btn {
  min-width: 40px;
  min-height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-tag-full-width {
  width: 100%;
  justify-content: center;
  text-align: center;
}
</style>
